import React from "react";
import InputRadioGroup from "../InputRadioGroup";

const InputRadioGroupSchema = (props) => <InputRadioGroup {...props} />;

export default InputRadioGroupSchema;
